import { fetchApiDataV2 } from "../../utils/utils";

export const fetchWatchlistShows = async (appInfo) => {
    const pubid = appInfo?.projectDetails?.projectConfig?.pubid || appInfo?.pubid;
    const isYowTv = Number(pubid) === 50187;
    const api = isYowTv ? "show/watchlistV2" : "show/watchlist";
    return await fetchApiDataV2(appInfo, api);
};

export const fetchWatchlistShowsV2 = async (appInfo) => {
    const api = "show/watchlistV2";
    return await fetchApiDataV2(appInfo, api);
};